"use strict";
/*jshint esversion: 11 */

import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import CsfMembreDispensesDataLayer, {
  DISPENSES_REASON_CODES
} from "./CsfMembreDispensesDataLayer";
import moment from "moment/moment";

export default function CsfMembreDispenseDeleteModal({exemptionItem, dispenseDataService}) {
  const [isError, setIsError] = useState(false);
  // can be used to close the modal: dismissButton.current.click();
  const dismissButton = useRef();
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [reason, setReason] = useState('');

  const dispenseDataServiceRef = useRef();
  const exemptionItemRef = useRef();

  // fields à gérer
  const ATTACHMENT_FIELDS = [
    "EM_Attachement",
    "EM_Attachement_2",
    "EM_Attachement_3",
    "EM_Attachement_4",
    "EM_Attachement_5"
  ];

  // liste des fichiers existants -- état initial : édition ou vide pour création
  const [attachments, setAttachments] = useState(() =>
    ATTACHMENT_FIELDS.reduce((acc, field) => ({
      ...acc,
      [field]: exemptionItem?.[field] || null,
    }), {})
  );

  useEffect(() => {
    if (dispenseDataService) {
      dispenseDataServiceRef.current = dispenseDataService;
    }
  }, [dispenseDataService]);

  useEffect(() => {
    setIsError(false);

    if (exemptionItem) {
      exemptionItemRef.current = exemptionItem;
    }

    setStartDate(exemptionItemRef.current?.Start_Date ? moment(exemptionItemRef.current?.Start_Date, "YYYY-MM-DD").format("YYYY-MM-DD") : '');
    setEndDate(exemptionItemRef.current?.End_Date ? moment(exemptionItemRef.current?.End_Date, "YYYY-MM-DD").format("YYYY-MM-DD") : '');
    setReason(exemptionItemRef.current?.Reason);

    // réinitialiser les fichiers initiaux existants
    setAttachments(
      ATTACHMENT_FIELDS.reduce((acc, field) => ({
        ...acc,
        [field]: exemptionItemRef.current?.[field] || null,
      }), {})
    );

  }, [exemptionItem]);


  function renderAttachmentField(field) {
    const filename = attachments[field];

    if (filename) {
      return (
        <div className="form-group file-row" key={field}>
          <div className="file-custom">
            <div className="selectedFile">
              <span className="visually-hidden">{window.Drupal.t('fournisseur.gestion.file.selected')} : </span>
              <span className="name">
                {filename}
              </span>
            </div>
          </div>
        </div>
      );
    }

    // Rien sinon
    return null;
  }


  return (
    <div className="modal fade" id="membreDispenseDeleteModal" tabIndex="-1" role="dialog" aria-labelledby="membreDispenseDeleteModalTitle"
      aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <form className="modal-content" onSubmit={(e) => {
            e.preventDefault();
            dispenseDataServiceRef.current.deleteDispense(
              exemptionItemRef.current.REDU_Exemption_Id,
              () => { window.location.reload(); },
              () => { setIsError(true); });
          }
        }>
          <div className="modal-header d-flex align-items-center">
            <h2 id="membreDispenseDeleteModalTitle">{window.Drupal.t('membre.dispense.modal.delete.title')}</h2>
            <button type="button" className="close" data-dismiss="modal" ref={dismissButton} aria-label={window.Drupal.t('lang.modal.close')}>
              <i className="icon icon-csf-close-noborder"><span className="d-none">&nbsp;</span></i>
            </button>
          </div>

          <div className="modal-body">
            {isError === true && (
              <div className="alert alert-danger" role="alert"
                aria-live="polite">{window.Drupal.t('broker.manager.error.message')}</div>
            )}
            <div className="row">
              <div className="col-12">
                <div className="form-group">
                  <label htmlFor="dispenses-delete-reason">{window.Drupal.t('membre.dispense.reason')}*</label>
                  <select id="dispenses-delete-reason" name="dispenses-delete-reason" value={`item-${reason}`} onChange={()=>{}} disabled>
                    <option value="" disabled></option>
                    {Object.values(DISPENSES_REASON_CODES).map((num) => (
                      <option key={'dispenses-raison-'+num} value={`item-${num}`}>
                        {CsfMembreDispensesDataLayer.getReasonDescriptionFromCode(num)}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12 col-md-6">
                <div className="form-group date">
                  <label htmlFor="dispenses-delete-start">{window.Drupal.t('Start date')}*</label>
                  <input
                    type="date"
                    id="dispenses-delete-start"
                    name="dispenses-delete-start"
                    defaultValue={startDate}
                    disabled
                  />
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="form-group date">
                  <label htmlFor="dispenses-delete-end">{window.Drupal.t('End date')}*</label>
                  <input
                    type="date"
                    id="dispenses-end"
                    name="dispenses-end"
                    defaultValue={endDate}
                    disabled
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                {ATTACHMENT_FIELDS.map(renderAttachmentField)}
              </div>
            </div>

            <div className="mt-1">
              <p className="m-0 larger-text text-center" dangerouslySetInnerHTML={{ __html: window.Drupal.t('membre.dispense.modal.delete.warning')}}></p>
            </div>
          </div>

          <div className="modal-footer">
              <div className="space-between-wrapper">
                <button type="button" className='button btn-pale btn-larger' data-dismiss="modal">{window.Drupal.t('fournisseur.back.btn')}</button>
                <input className="btn-submit btn-red btn-larger" type="submit" value={window.Drupal.t('delete.btn')}/>
              </div>
            </div>
        </form>
      </div>
    </div>
  )
}

CsfMembreDispenseDeleteModal.propTypes = {
  exemptionItem: PropTypes.object,
  dispenseDataService: PropTypes.oneOfType([
    PropTypes.instanceOf(CsfMembreDispensesDataLayer),
    PropTypes.object, // éviter warning du mauvais type avant son initialisation
  ]),
};

